module.exports = __webpack_public_path__ + "static/media/random_white.593a19b4.png";